import { useLazyQuery, useQuery } from "@apollo/client";
import { STOCK_UNIT } from "../stock-unit.queries";
import {
  StockUnitQuery,
  StockUnitQueryVariables,
} from "../../../__generated__/StockUnitQuery";

export const useStockUnit = (id: number) => {
  return useQuery<StockUnitQuery, StockUnitQueryVariables>(STOCK_UNIT, {
    variables: { id },
  });
};

export const useLazyStockUnit = () => {
  return useLazyQuery<StockUnitQuery, StockUnitQueryVariables>(STOCK_UNIT);
};
